import React from 'react';

const CloseIcon = () => {
	return (
		<svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M8.4 7C8.4 7 12 3.4 13.2 2.2C13.6 1.8 13.6 1.2 13.2 0.8C12.8 0.4 12.2 0.4 11.8 0.8C10.6 2 7 5.6 7 5.6C7 5.6 3.4 2 2.2 0.8C1.8 0.4 1.2 0.4 0.8 0.8C0.4 1.2 0.4 1.8 0.8 2.2C2 3.4 5.6 7 5.6 7C5.6 7 2 10.6 0.8 11.8C0.4 12.2 0.4 12.8 0.8 13.2C1.2 13.6 1.8 13.6 2.2 13.2C3.4 12 7 8.4 7 8.4C7 8.4 10.6 12 11.8 13.2C12.2 13.6 12.8 13.6 13.2 13.2C13.6 12.8 13.6 12.2 13.2 11.8C12 10.6 8.4 7 8.4 7Z' />
		</svg>
	);
};

const Rounded = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path fillRule="evenodd" clipRule="evenodd" d="M1.33325 7.99967C1.33325 4.33301 4.33325 1.33301 7.99992 1.33301C11.6666 1.33301 14.6666 4.33301 14.6666 7.99967C14.6666 11.6663 11.6666 14.6663 7.99992 14.6663C4.33325 14.6663 1.33325 11.6663 1.33325 7.99967ZM10.7999 5.19967C11.0666 5.46634 11.0666 5.86634 10.7999 6.13301L8.93325 7.99967L10.7999 9.86634C11.0666 10.133 11.0666 10.533 10.7999 10.7997C10.5333 11.0663 10.1333 11.0663 9.86659 10.7997L7.99992 8.93301L6.13325 10.7997C5.86659 11.0663 5.46659 11.0663 5.19992 10.7997C4.93325 10.533 4.93325 10.133 5.19992 9.86634L7.06659 7.99967L5.19992 6.13301C4.93325 5.86634 4.93325 5.46634 5.19992 5.19967C5.46659 4.93301 5.86659 4.93301 6.13325 5.19967L7.99992 7.06634L9.86659 5.19967C10.1333 4.93301 10.5333 4.93301 10.7999 5.19967Z" />
		</svg>
	);
};

CloseIcon.Rounded = Rounded;

export default CloseIcon;
